import React from 'react';

const WhyButton = ({ 
  onClick, 
  title = "Why create an account?",
  style = {},
  className = "",
  children = "?"
}) => {
  return (
    <button
      onClick={onClick}
      className={className}
      title={title}
      style={{
        position: 'absolute',
        bottom: '-8px',
        right: '-8px',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        border: '1px solid var(--pista-button-bg, #2E7D32)',
        backgroundColor: 'var(--bg-primary, #fff)',
        color: 'var(--pista-button-bg, #2E7D32)',
        fontSize: '0.7rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        zIndex: 1,
        ...style
      }}
    >
      {children}
    </button>
  );
};

export default WhyButton;
